export const AuthenticationResources = {
  SignIn: 'sign-in',
  Refresh: 'refresh',
  SignOut: 'sign-out',
  SignUp: 'sign-up',
  Users: 'users',
  Profile: 'profile',
} as const;
